<template>
  <v-card>
    <v-card-title>
      <span class="headline">Add Symptom or Prevention Form</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="6" sm="12" md="6">
            <v-select
              v-model="select"
              :items="items"
              :rules="[(v) => !!v || 'Item is required']"
              label="Form type"
              required
            ></v-select>
          </v-col>

          <v-col cols="6" sm="12" md="6">
            <v-select
              v-model="selected_lang"
              :items="lang_items"
              :rules="[(v) => !!v || 'Item is required']"
              label="Language"
              required
            ></v-select>
          </v-col>

          <v-col v-if="select === 'Symptom'" cols="12" sm="12" md="12">
            <v-text-field
              v-model="title"
              label="Title of the Symptom"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="select === 'Prevention'" cols="12" sm="12" md="12">
            <v-text-field
              v-model="title"
              label="Title of the Prevention"
              required
            ></v-text-field>
          </v-col>

          <v-col v-if="select === 'Symptom'" cols="12" sm="12" md="12">
            <v-text-field
              v-model="caption"
              label="Caption of the Symptom"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="select === 'Prevention'" cols="12" sm="12" md="12">
            <v-text-field
              v-model="caption"
              label="Caption of the Prevention"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-textarea
              v-model="description"
              v-if="select === 'Symptom'"
              name="input-7-1"
              label="Body of the Symptom"
              value=""
              hint="Write the entire Symptom"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
              v-model="description"
              v-if="select === 'Prevention'"
              name="input-7-1"
              label="Body of the Prevention"
              value=""
              hint="Write the entire Prevention"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              label="Image link for the News"
              v-model="imagePath"
              readonly
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <div class="container upload-image-offset">
              <div class="row justify-content-center">
                <div class="col-12"><image-upload :title="upload" /></div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <small>*indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="this.triggerCloseDialog">
        Close
      </v-btn>
      <v-btn color="blue darken-1" text @click="this.saveForm"> Save </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { eventBus } from "@/main.js";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import imageUpload from "../shared/components/imageUpload";
export default {
  components: { imageUpload },
  computed: {
    ...mapFields("shared", ["imagePath"]),
  },
  data: () => ({
    select: null,
    caption: "",
    description: "",
    image: "",
    title: "",
    items: ["Symptom", "Prevention"],
    upload: "upload an image",
    lang_items: ["en", "ar", "am"],
    selected_lang: "en",
}),
  methods: {
    ...mapActions("symptom_prevent", ["addSymptoms", "addPrevents", "fetchTotalSymptoms", "fetchTotalPreventions"]),
    ...mapActions("shared", ["clearImagePath"]),
    triggerCloseDialog(value) {
      eventBus.$emit("dialogToggle", false);
    },
    async saveForm() {
      if (this.select === null) {
        alert("Select atleast one form type!");
        return;
      }

      // for Symptoms
      if (this.select === "Symptom") {
        try {
          this.addSymptoms({
            payload: {
              symptom: {
                caption: this.caption,
                description: this.description,
                image: this.imagePath,
                title: this.title,
              },
            lang:this.selected_lang,
            },
          });
          eventBus.$emit("dialogToggle", false);
          (this.select = null),
            (this.caption = ""),
            (this.description = ""),
            (this.title = ""),
            this.clearImagePath();
          
          await this.fetchTotalSymptoms(this.selected_lang)
          alert("Successfully Added Symptom!");
        } catch (error) {
          alert("Failed to create Symptom!");
        }
      }

      // for preventions
      if (this.select === "Prevention") {
        try {
          this.addPrevents({
            payload: {
              prevent: {
                caption: this.caption,
                description: this.description,
                image: this.imagePath,
                title: this.title,
              },
            lang:this.selected_lang,
            },
          });
          eventBus.$emit("dialogToggle", false);
          (this.select = null),
            (this.caption = ""),
            (this.description = ""),
            (this.title = ""),
            this.clearImagePath();
          await this.fetchTotalPreventions(this.selected_lang);
          alert("Successfully Added Prevention!");
        } catch (error) {
          alert("Failed to create Prevention!");
        }
      }
    },
  },
};
</script> 